function showEnterAddressManuallyLink() {
    $("#edit-address-manually").show();
}

function hideEnterAddressManuallyLink() {
    $("#edit-address-manually").hide();
}

function showPostcodeSearchNoResultsError() {
    $("#postcode-no-results-error-msg").show();
}

function hidePostcodeSearchNoResultsError() {
    $("#postcode-no-results-error-msg").hide();
}

function showPostcodeSearchErrorMsg() {
    $("#postcode-search-error-msg").show();
}
function hidePostcodeSearchErrorMsg() {
    $("#postcode-search-error-msg").hide();
}
function showUnrecognisedPostcodeErrorMsg() {
    $("#postcode-invalid-error-msg").show();
}
function hideUnrecognisedPostcodeErrorMsg() {
    $("#postcode-invalid-error-msg").hide();
}

function findAddressButton() {
    return $("#find-address-current-button");
}

function addSpinnerOnFindAddressButton() {
    var addressBtn = findAddressButton();
    addressBtn.addClass("btn-loading");
}

function removeSpinnerForFindAddress() {
    findAddressButton().removeClass("btn-loading");
}

function whenPostCodeSearch(callback) {
    $("#postcode-search-div").on("submit", function (event) {
        event.stopPropagation();
    });

    findAddressButton().on("click", function (event) {
        event.preventDefault();
        callback($("#postcode").val());
    });
}

function showAddressesList(addressesHtml) {
    $("#postcode-search-results-placeholder").html(addressesHtml);
    $("#postcode-search-results").show();
}

function whenEnterKeyPressedInPostcodeSearch(callback) {
    $("#postcode").keypress(callback);
}


function getPostcodeSearchValue() {
    return $("#postcode").val();
}

function isPostcodeValueInAValidFormat() {
    var isPostcodeEmpty = getPostcodeSearchValue() === "";
    var isValidPostcodeFormat = $('#postcode').parsley('validate').isValid();
    return !isPostcodeEmpty && isValidPostcodeFormat;
}

function validatePostcodeInput() {
    $('#postcode').parsley().validate();
}

module.exports = {
    addSpinnerOnFindAddressButton: addSpinnerOnFindAddressButton,
    hidePostcodeSearchErrorMsg: hidePostcodeSearchErrorMsg,
    hideUnrecognisedPostcodeErrorMsg: hideUnrecognisedPostcodeErrorMsg,
    isPostcodeValueInAValidFormat: isPostcodeValueInAValidFormat,
    whenEnterKeyPressedInPostcodeSearch: whenEnterKeyPressedInPostcodeSearch,
    whenPostCodeSearch: whenPostCodeSearch,
    getPostcodeSearchValue: getPostcodeSearchValue,
    removeSpinnerForFindAddress: removeSpinnerForFindAddress,
    showAddressesList: showAddressesList,
    showPostcodeSearchErrorMsg: showPostcodeSearchErrorMsg,
    showUnrecognisedPostcodeErrorMsg: showUnrecognisedPostcodeErrorMsg,
    validatePostcodeInput: validatePostcodeInput,
    showEnterAddressManuallyLink: showEnterAddressManuallyLink,
    hideEnterAddressManuallyLink: hideEnterAddressManuallyLink,
    showPostcodeSearchNoResultsError: showPostcodeSearchNoResultsError,
    hidePostcodeSearchNoResultsError: hidePostcodeSearchNoResultsError
};
